module.exports = __webpack_public_path__ + "static/media/stream.ec4a3de0.svg";